import { entitiesReducer } from "EntitiesApi/Reducers";
import { rootSaga as apiSaga } from "EntitiesApi/Sagas";
import { combineReducers, createStore as createReduxStore, applyMiddleware } from "redux";
import honeybadgerMiddleware from "Redux/Middleware/honeybadgerMiddleware";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import createSagaMiddleware from "redux-saga";
import { fork } from "redux-saga/effects";

import { accountId } from "./reducers";

import type { EntityTable } from "EntitiesApi/Reducers";
import type { Store, CombinedReducer } from "redux";
import type { Account, CompanyPolicy, CompanyProfile, EmployeeDependent, EmployeeForm, EmployeePolicy, EmployerForm, Plan } from "Utils/types";

export type State = {
  accountId: string;
  entities: {
    accounts: EntityTable<Account>;
    companyPolicies: EntityTable<CompanyPolicy>;
    companyProfiles: EntityTable<CompanyProfile>;
    employeeDependents: EntityTable<EmployeeDependent>;
    employeeForms: EntityTable<EmployeeForm>;
    employeePolicies: EntityTable<EmployeePolicy>;
    employerForms: EntityTable<EmployerForm>;
    medicalPlans: EntityTable<Plan>;
    dentalPlans: EntityTable<Plan>;
    visionPlans: EntityTable<Plan>;
  };
};

export type Action = {
  readonly type: string;
  readonly payload: any;
};

const rootReducer: CombinedReducer<State, Action> = combineReducers({
  accountId,
  entities: entitiesReducer({
    accounts: {},
    companyPolicies: {},
    companyProfiles: {},
    employeeDependents: {},
    employeeForms: {},
    employeePolicies: {},
    employerForms: {},
    medicalPlans: {},
    dentalPlans: {},
    visionPlans: {},
  }) as any,
});

const sagaMiddleware = createSagaMiddleware();

function* rootSaga() {
  yield fork(apiSaga);
}

const createStore = (initialState: Partial<State>): Store<State, Action> => {
  const store = createReduxStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(sagaMiddleware, honeybadgerMiddleware)));

  sagaMiddleware.run(rootSaga);
  return store;
};

export default createStore;
